import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { cn } from "../lib/utils";

/**
 * Bundled shadcn checkbox. The Check glyph is rendered as an inline
 * SVG instead of `lucide-react`'s `Check` so the package doesn't have
 * to peer-pin lucide-react's version against whatever the host app
 * happens to be on (apps/web is on an older release with narrower
 * `LucideProps` types).
 */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Forms design language: token border at rest, accent fill when checked.
      "peer h-[18px] w-[18px] shrink-0 rounded-[5px] border-[length:var(--forms-input-border-w)] border-[var(--forms-border)] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--forms-accent,var(--forms-accent-default))]/40 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[var(--forms-accent,var(--forms-accent-default))] data-[state=checked]:bg-[var(--forms-accent,var(--forms-accent-default))] data-[state=checked]:text-white",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-4 w-4"
        aria-hidden
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
